<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='success' size='mini' icon='el-icon-plus' @click='toCreateB') B - 新規作成
    el-button(type='success' size='mini' icon='el-icon-plus' @click='toCreateA') A - 新規作成
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='showModal') 順番変更
  .contents-container
    .c-search
      el-input(placeholder='検索条件を入れてください', v-model='search')
    el-table.c-table(:data='searchedData' style='width: 100%' v-loading='LOADING')
      el-table-column(prop='main_video', label='', width='120')
        template(slot-scope='scope')
          template(v-if='scope.row.main_video.image')
            img.c-thumb__item--s(:src='scope.row.main_video.image.uri')
          template(v-else)
            .c-thumb__item--s
              p no image
      el-table-column(prop='title.ja' label='Title')
      el-table-column(prop='date' label='Date' width='180')
      el-table-column(prop='work_type', label='Work Type', width='100')
        template(slot-scope='scope')
          | {{workType(scope.row.work_type)}}
      el-table-column(prop='status', label='Status', width='100')
        template(slot-scope='scope')
          el-tag(:type="scope.row.status === 1 ? 'success' : 'info'") {{status(scope.row.status)}}
      el-table-column(label='', width='100')
        template(slot-scope='scope')
          el-button(size='mini', @click='handleEdit(scope.row, "worksDetail" + scope.row.work_type)' icon='el-icon-edit') Edit
    template(v-if='list.length')
      modal-sort-element(:visible='modalvisible' @hideModal='hideModal' @saveSort='saveSort' :list='list' type='list')
</template>

<script>
import list from '@/mixins/list'
import Sticky from '@/components/Element/Sticky'
import ModalSortElement from '@/components/Element/Modal/SortElement'
export default {
  name: 'PagesWorks',
  mixins: [list],
  data () {
    return {
    }
  },
  methods: {
    init () {
      this.getList()
    },
    toCreateA () {
      this.$router.push({name: 'worksCreateA'})
    },
    toCreateB () {
      this.$router.push({name: 'worksCreateB'})
    },
    workType (data) {
      return (data === 1) ? 'A' : 'B'
    }
  },
  created () {
    this.init()
  },
  components: {
    Sticky,
    ModalSortElement
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Works/index.vue